import { useState, useEffect } from "react";
import "./BannerCarousel.css";
import banner1 from "../../assets/home/banners/banner1.jpeg";
import banner2 from "../../assets/home/banners/banner2.jpeg";

const banners = [banner1, banner2];

function BannerCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(null);
  const [direction, setDirection] = useState("next");

  useEffect(() => {
    const interval = setInterval(() => {
      setDirection("next");
      setNextIndex((currentIndex + 1) % banners.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  useEffect(() => {
    if (nextIndex !== null) {
      const timer = setTimeout(() => {
        setCurrentIndex(nextIndex);
        setNextIndex(null);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [nextIndex]);

  const goToPrevious = () => {
    setDirection("prev");
    setNextIndex((currentIndex - 1 + banners.length) % banners.length);
  };

  const goToNext = () => {
    setDirection("next");
    setNextIndex((currentIndex + 1) % banners.length);
  };

  return (
    <section className="banner-carousel">
      <div className="carousel-container">
        <div
          className="carousel-image carousel-image-current"
          style={{
            backgroundImage: `url(${banners[currentIndex]})`,
          }}
        ></div>
        {nextIndex !== null && (
          <div
            className={`carousel-image carousel-image-next ${direction}`}
            style={{
              backgroundImage: `url(${banners[nextIndex]})`,
            }}
          ></div>
        )}
      </div>

      <button className="carousel-btn carousel-btn-prev" onClick={goToPrevious}>
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        </svg>
      </button>

      <button className="carousel-btn carousel-btn-next" onClick={goToNext}>
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        </svg>
      </button>

      <div className="carousel-indicators">
        {banners.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentIndex ? "active" : ""}`}
            onClick={() => {
              setDirection("next");
              setNextIndex(index);
            }}
          ></button>
        ))}
      </div>
    </section>
  );
}

export default BannerCarousel;
